import { WSQueryConfig } from "@ws-react-query";

import { useWSQuery } from "../../helpers";
import { QUERY_MONITOR_SETTINGS_ITEM } from "../keys";
import { IInsuranceCoverageMonitorSettings } from "../../../services/api/insurance/monitorSettings/types";
import { getMonitorSettingsItem } from "../../../services/api/insurance/monitorSettings/getMonitorSettingsItem";

export const useQueryMonitorSettings = (
  monitorSettingsId: string,
  queryConfig?: WSQueryConfig<IInsuranceCoverageMonitorSettings, unknown>
) =>
  useWSQuery(
    [QUERY_MONITOR_SETTINGS_ITEM, monitorSettingsId],
    () => getMonitorSettingsItem(monitorSettingsId),
    {
      retry: false,
      refetchOnMount: false,
      ...queryConfig
    }
  );
